import store from "../../context/store/store";
import { Types } from '../../context/action/action';
import { contacts, UserDetails } from "../../models/model";
import moment from "moment";
import { eventService } from "./event.service";
import { RRule } from 'rrule';
//*import { getcontactDetail } from "../utils";
import { toastInformation } from "../callService/common";
import { config } from "../constant";
import { loadScreen, NotifiyRedirect } from "../socketChatService/utils";
// need to implement the logic
export const saveEventCreation = async(formData:any,key:any) => {
  try {
    
    let loginUser: any = store.getState().loginReducer.userdetails || [];
    loginUser['jid']= loginUser.sip_login_id + '@' + loginUser.host_address;
    let { chatWindowDetails}:any = store.getState().chatWindowReducer;
    let { contactWindowDetails}:any = store.getState().contactWindowReducer;
    let contactDetail:any = key === 'contact'?contactWindowDetails:key === 'loginuser'?loginUser:
      chatWindowDetails;
    //*let {xmppDetails}:any = store.getState().chatReducer;
    let participants: any = [];
    formData.participants.forEach((data: any) => {
      participants.push(data?.toString());
    });
    //formData.time.getHours() + ':' + formData.time.getMinutes();
    let sTime = formData.time;
    let startDateTime = moment(formData.startDate).format('YYYY/MM/DD') + ' ' + sTime;
    var endDateTime = new Date(startDateTime);
   
    endDateTime.setHours(endDateTime.getHours() + parseInt(formData.hours));
    endDateTime.setMinutes(endDateTime.getMinutes() + parseInt(formData.minutes));

    let data = {
      "companyId": loginUser.company_id,
      "summary": formData.eventName,
      "calender": formData.calendarType,
      "inviteParticipants": participants,
      "description": formData.description,
      "location": "",
      "groupId": 'team_id' in contactDetail ? contactDetail.team_id : "",
      "ownerId": loginUser.sip_login_id,
      "sip_id": loginUser.sip_login_id,
      "sender":loginUser.sip_login_id,
      "receiver": 'team_id' in contactDetail ? contactDetail.team_id : contactDetail.sip_login_id,
      "repeat": {
        "time": "",
        "type": "",
        "when": ""
      },
      "dtstart": (new Date(startDateTime).getTime() / 1000).toFixed(0),
      "dtend": (new Date(endDateTime).getTime() / 1000).toFixed(0),
      "duration":(new Date(endDateTime).getTime() / 1000).toFixed(0),
      "recurOptions": "None",
      "stopRecur": "",
      "reminder": "No reminder",
      "rrule": "",
      "status": false,
      "allDay": formData.allDay ? "true" : "false",
      "section": "",
      "trigger": "",
      "threadId": "",
      "replaceId": "",
      "domainId":loginUser.domain_id

    };
    new eventService().createEvent(data)
      .then((res: any) => {
       
        // if(key!=="loginuser"){
        //   chatSideWindow(true,"eventlist",{});
        // }
       
        if(res.statusCode === 200){
          if(formData.calendarType === 'outlook'){
            createOutlookLink(formData);
          } else if(formData.calendarType === 'google'){
            createGoogleLink(formData,endDateTime);
          }
          store.dispatch({
            type: Types.CONTACT_EVENT_UPDATE,
            payload:{
              isEventUpdate: true
            }
          });
          toastInformation(config().EVENTCREATE, 'success');
          ToastEventView(true,res,key);  
        }
       
      }).catch((error: any) => {
        console.log(error, 'error');

      });
  }
  catch (error: any) { console.log("error", error); }
};

export const chatSideWindow = (data: boolean,isKey:string,editdata:any) => {
  store.dispatch({
    type: Types.CHAT_WINDOW_SLIDE_OPEN,
    payload: {
      isWindowSlide: data,
      isKey:isKey,
      isEdit:editdata
    }
  });
};

export const weekRRulelist = (data: string) => {
  let newData:any =(data.substring(0, data.length - 1)).toUpperCase();
  let rule:any = RRule;
  return rule[newData];
};

export const weekRRuleOfMonth = (data: any,week:any) => {
 
  let weekNo = week === 'First'?-1:week === 'Second'?-2:week === 'Third'?-3:week === 'Fourth'?-4:-5;
  let newData:any =(data.substring(0, data.length - 1)).toUpperCase();
  let rule:any = RRule;
  return  rule[newData].nth(weekNo);
};

export const weekRRuleOfMonths = (data: any,week:any) => {
  let weekNo = week === 'First'?-1:week === 'Second'?-2:week === 'Third'?-3:week === 'Fourth'?-4:-5;
  let newData:any =(data.substring(0, data.length - 1)).toUpperCase();
  let rule:any = RRule;
  return  rule[newData].nth(weekNo);
};

export const RRuleGeneration = (formData:any,eventdata:any) => {

  let freq_recurrence = formData.recurrence === "Weekly"?RRule.WEEKLY:formData.recurrence === "Monthly"?
    RRule.MONTHLY : RRule.DAILY;
  let sTime = eventdata.time;
  let startDateTime = moment(eventdata.startDate).format('YYYY/MM/DD') + ' ' + sTime;
  let weeklyOccuron: any = [];
  if(formData.recurrence === "Weekly"){
    formData?.weeklyOccuron.forEach((data: any) => {
      let reculist = weekRRulelist(data);
      weeklyOccuron.push(reculist);
    });
  }
  if(formData.recurrence === "Monthly" && formData.occureon === 4){
    let reculist = weekRRuleOfMonth(formData.monthlyDay,formData.monthlyWeek);
    weeklyOccuron.push(reculist);
  } 

  const rruleObject:any = {
    freq: freq_recurrence,
    dtstart: new Date(startDateTime),
    byweekday: weeklyOccuron,
    interval:formData.repeat_every
  };
  if(formData.recurrence === "Monthly" && formData.occureon === 3){
    rruleObject['bymonthday'] = formData?.occurMonthday
  }
  if(formData.afteroccur !== 0){
    rruleObject['count'] = formData?.afteroccur
  } else {
    rruleObject['until'] = new Date(eventdata.endDate)
  }
  return new RRule(rruleObject);
  
};
export const ToastEventView = (Type:boolean,res:any,location:any)=>{
  store.dispatch({
    type: Types.VIEW_EVENTS_FROM_TOAST,
    payload: {
      isEventviewontoast: Type,
      Eventviewontoast: res,
      isViewbutton:location==="loginuser"?true:false,
      isTaskviewontoast:false,
      Taskviewontoast:{},
      isNotesviewontoast:false,
      notesviewontoast:{}
    }
  });
setTimeout(function() {
  store.dispatch({
  type: Types.VIEW_EVENTS_FROM_TOAST,
  payload: {
    isEventviewontoast: false,
    Eventviewontoast: {},
    isTaskviewontoast:false,
    Taskviewontoast:{},
    isNotesviewontoast:false,
    notesviewontoast:{}
  }
 });
},5000);
}
export const TaskRRuleGeneration = (formData:any,eventdata:any) => {

  let freq_recurrence = formData.recurrence === "Weekly"?RRule.WEEKLY:formData.recurrence === "Monthly"?
    RRule.MONTHLY : RRule.DAILY;
  let sTime = eventdata.startTime;
  let startDateTime = moment(eventdata.startDate).format('YYYY/MM/DD') + ' ' + sTime;
  let weeklyOccuron: any = [];
  if(formData.recurrence === "Weekly"){
    formData?.weeklyOccuron.forEach((data: any) => {
      let reculist = weekRRulelist(data);
      weeklyOccuron.push(reculist);
    });
  }
  if(formData.recurrence === "Monthly" && formData.occureon === 4){
    let reculist = weekRRuleOfMonth(formData.monthlyDay,formData.monthlyWeek);
    weeklyOccuron.push(reculist);
  }
  const rruleObject:any = {
    freq: freq_recurrence,
    dtstart: new Date(startDateTime),
    byweekday: weeklyOccuron,
    interval:formData.repeat_every
  };
  if(formData.recurrence === "Monthly" && formData.occureon === 3){
    rruleObject['bymonthday'] = formData?.occurMonthday
  }
  if(formData.afteroccur !== 0){
    rruleObject['count'] = formData?.afteroccur
  } else {
    rruleObject['until'] = new Date(eventdata.endDate)
  }
  return new RRule(rruleObject);
  
};

export const updateEventCreation = async(formData:any,key:any) => {
  try {
    let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
    
    let { chatWindowDetails}:any = store.getState().chatWindowReducer;
    let { contactWindowDetails}:any = store.getState().contactWindowReducer;
    let contactDetail:any = key === 'contact'?contactWindowDetails:key === 'loginuser'?loginUser:
    chatWindowDetails;
 
    let participants: any = [];
    formData.participants.forEach((data: any) => {
      participants.push(data?.toString());
    });

    let sTime = formData.time;
    let startDateTime = moment(formData.startDate).format('YYYY/MM/DD') + ' ' + sTime;
    
    let data = {
      "companyId": loginUser.company_id,
      "summary": formData.eventName,
      "calender": formData.calendarType,
      "inviteParticipants": participants,
      "description": formData.description,
      "location": formData.location,
      "groupId": 'team_id' in contactDetail ? contactDetail.team_id : "",
      "ownerId": loginUser.sip_login_id,
      "sip_id": loginUser.sip_login_id,
      "sender":formData.sender,
      "receiver": formData.receiver,
      "repeat": {
        "time": "",
        "type": "",
        "when": ""
      },
      "dtstart": (new Date(startDateTime).getTime() / 1000).toFixed(0),
      "dtend": (new Date(formData.endDate).getTime() / 1000).toFixed(0),
      "duration":formData.duration,
      "recurOptions": formData.recurrence,
      "stopRecur": "",
      "reminder": formData.reminder,
      "rrule": formData.rruleValue,
      "status": false,
      "allDay": formData.allDay ? "true" : "false",
      "section": "",
      "trigger": "",
      "threadId": "",
      "replaceId": "",
      "domainId":loginUser.domain_id

    };
  
    
    new eventService().editEvent(formData.taskId, data)
      .then((res: any) => {
        
        if(formData.calendarType === 'outlook'){
          createOutlookLink(formData);
        } else if(formData.calendarType === 'google'){
          createGoogleLink(formData,formData.endDate);
        }
        store.dispatch({
          type: Types.CONTACT_EVENT_UPDATE,
          payload:{
            isEventUpdate: true
          }
        });
        toastInformation(config().EVENTEDIT, 'success');
      }).catch((error: any) => {
        console.log(error, 'error');
      });
  }
  catch (error: any) { console.log("error", error); }
};

const createGoogleLink = (data: any,endDate:any) => {
  let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let {allContacs} :contacts = store.getState().contactReducer;
  let participants: any = [];
  data.participants.forEach((exe: any) => {
    let part:any = allContacs.find((List: any) => List.sip_login_id && List.sip_login_id.toString() === exe.toString());
    participants.push(part?.email_id);
  });
  const meetingDetails = loginUser.caller_id + " has created a new event" +
   ' \n\n' +
    "Title : " + data.eventName + ' \n\n' +
    "About Event : " + data.description + ' \n\n';
  const startTime = new Date(data.startDate);
  const startDateTimeFormatted = moment.utc(startTime).format("YYYYMMDDTHHmmss[Z]");
  const endDateTimeFormatted = moment.utc(endDate).format("YYYYMMDDTHHmmss[Z]");
  const generateURL = encodeURI(`https://www.google.com/calendar/render?action=TEMPLATE&text=${data.eventName}`+
  `&dates=`+
 `${startDateTimeFormatted}/${endDateTimeFormatted}&details=${meetingDetails}&location=NA`+
 `+&sf=true&output=xml`);
  window.open(generateURL,'_blank');
};
const createOutlookLink = (data:any) =>{
  let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let {allContacs} :contacts = store.getState().contactReducer;
  let participants: any = [];
  data.participants.forEach((exe: any) => {
    let part:any = allContacs.find((List: any) => List.sip_login_id && List.sip_login_id.toString() === exe.toString());
    participants.push(part?.email_id);
  });
  const meetingDetails=loginUser.caller_id+ " has created a new event" +
   ' \n\n' +
    "Title : " + data.eventName + ' \n\n' +
    "About Event : " + data.description + ' \n\n';
  let time = new Date(data.startDate).toISOString();
  let end = new Date(data.endDate).toISOString();
  // eslint-disable-next-line max-len
  const generateURL = encodeURI(`https://outlook.office.com/owa/?path=/
calendar/action/compose&rru=addevent&startdt=${time}&enddt=${end}&subject=${data.eventName}
&to=${participants}&location=N/A&body=${meetingDetails}&path=/calendar/view/Month`);
  window.open(generateURL,'_blank');

};


export const deleteEventCreation = async(data:any) => {
  try {
  let loginUser: any = store.getState().loginReducer.userdetails;
  let taskData = {
    uid: data.taskId,
    domainId: loginUser.domain_id
  };
  return new eventService().deleteEvent(taskData)
    .then((res: any) => {
      if (res.statusCode === 200) {
        store.dispatch({
          type: Types.CONTACT_EVENT_UPDATE,
          payload:{
            isEventUpdate: true
          }
        });
        toastInformation(config().EVENTDELETE, 'success');
      }

    }).catch((error: any) => {
      console.log(error, 'error');

    });
  }
  catch (error: any) { console.log("error", error); }
}

export const callmeetingnotification = async() => {
  try {
  
    return new eventService().getBellNotification().then((response: any) => {
      store.dispatch({
        type: Types.MEETING_NOTIFICATIONS,
        payloads:response.result
      })
    }).catch((error: any) => {
          console.log(error, 'error');
     });

  // return new eventService().getCallMeetingBellNotificationList(type)
  //   .then((response: any) => {
  //     if(type===3){
  //       store.dispatch({
  //         type: Types.CALL_NOTIFICATIONS,
  //         payloads: response.result
  //       })
  //     }else {
  //       store.dispatch({
  //         type: Types.MEETING_NOTIFICATIONS,
  //         payloads:response.result
  //       })
  //     }

  //   }).catch((error: any) => {
  //     console.log(error, 'error');

  //   });
  }
  catch (error: any) { console.log("error", error); }
}

export const callmeetingnotificationRead = async(value:any, location: any) => {
  try {
  if(value.type===3 || value.type===4){
    return new eventService().getCallMeetingBellNotificationRead(value._id)
    .then((res: any) => {
      if (res.statusCode === 200) {
        if(value.type===3){
          location.push('/calls');
        }else {
          window.open(value.message.invite_url, '_blank');
        }
      }
    }).catch((error: any) => {
      console.log(error, 'error');
    });
  }else if(value.type===1 ||value.type===2 ){
    NotifiyRedirect(value);
  }
 
  }
  catch (error: any) { console.log("error", error); }
}


export const getVideoMeetSetting = async() => {
  try {
    new eventService().getSettings()
    .then((response: any) => {
      if(response.statusCode === 404){
        let data = {
          wating_room: false,
          passcode_participants: true,
          passcode_invite_link: true,
          personal_meeting_id: false,
          host_video: true,
          participants_video: true,
          allow_partiipants_before_host: false,
          enable_personal_meeting_id: false,
          schedule_personal_meeting_id: false,
          instant_personal_meeting_id: false,
          mute_all_participants: false,
          meeting_chat: true,
          sound_notification: true,
          screen_share: true,
          allow_removed_participants_to_rejoin: false,
          allow_participants_to_rename_themselves: true,
          full_transcript: false,
          virtual_background: true,
          request_permission_to_mute: false,
          passcode:""
        }
        saveVideoSetting(data);
      } else {
        store.dispatch({
          type: Types.VIDEO_PROFILE_SETTING,
          payload: {
            videoprofileData:response?.result,
            isvideoprofile: true
          }
        });
      }
      console.log("response---", response);
    })
    .catch((err: any) => {
      console.log("err---", err);
    });

  }
  catch (error: any) { console.log("error", error); }
};

export const saveVideoSetting = async(formData:any) => {
  try {
    let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
    let data = {
      "sipId": loginUser?.sip_login_id,
    "security": {
        "wating_room": formData.wating_room,
        "passcode_participants": formData.passcode_participants,
        "passcode_invite_link": formData.passcode_invite_link,
        "personal_meeting_id": formData.personal_meeting_id,
        "passcode": formData.passcode
    },
    "schedule": {
        "host_video": formData.host_video,
        "participants_video": formData.participants_video,
        "allow_partiipants_before_host": formData.allow_partiipants_before_host,
        "enable_personal_meeting_id": formData.enable_personal_meeting_id,
        "schedule_personal_meeting_id": formData.schedule_personal_meeting_id,
        "instant_personal_meeting_id": formData.instant_personal_meeting_id,
        "mute_all_participants": formData.mute_all_participants
    },
    "in_meeting_basics": {
        "meeting_chat": formData.meeting_chat,
        "sound_notification": formData.sound_notification,
        "screen_share": formData.screen_share,
        "allow_removed_participants_to_rejoin": formData.allow_removed_participants_to_rejoin,
        "allow_participants_to_rename_themselves": formData.allow_participants_to_rename_themselves
    },
    "in_meeting_advance": {
        "full_transcript": formData.full_transcript,
        "virtual_background": formData.virtual_background,
        "request_permission_to_mute": formData.request_permission_to_mute
    }
    }
    new eventService().saveVideoMeetSetting(data)
      .then((res: any) => {
        console.log(res, 'error');
        if(res.statusCode === 200){
          store.dispatch({
            type: Types.VIDEO_PROFILE_SETTING,
            payload: {
              videoprofileData:data,
              isvideoprofile: true
            }
          });
        }
       
      }).catch((error: any) => {
        console.log(error, 'error');

      });
  }
  catch (error: any) { console.log("error", error); }
};

export const getTemporyContactList = async() => {
  try {
  
    return new eventService().getTemporyContactList().then((response: any) => {
      let objectList: any = [];
      objectList = [...response.companyContacts].reduce((acc: any, curr: any) => {
        //const participant: any = userstatus[curr.sip_login_id];
        if (curr?.sip_login_id && curr["sip_login_id"]) {
          curr['sip_login_id'] = curr?.sip_login_id.toString();
          return (acc[curr["sip_login_id"]] = curr, acc);
        } else {
          return null;
        }
      }, {});
      const objectListteam = response.team_info.reduce((acc: any, curr: any) => {
        if (curr?.team_id) {
          return (acc["con" + curr["team_id"]] = curr, acc);
        } else {
          return null;
        }
      }, {});
      console.log(objectList)
      store.dispatch({
        type: Types.TEMPORY_CONTACT_LIST,
        payload:{
          temporyContact:objectList,
          temporyTeamContact:objectListteam
        }
      })
      store.dispatch({
        type: Types.ALL_CONTACT_LOADING,
        payload: {
          allContacsLoading: true
        }
      });
      loadScreen(false)
    }).catch((error: any) => {
          console.log(error, 'error');
     });


  }
  catch (error: any) { console.log("error", error); }
}

export const saveBlockUnblock = async(formData:any,userdata:any) => {
  try {
    let loginUser: UserDetails = store.getState().loginReducer.userdetails || [];
    let data = {
      "companyId": userdata?.company_id,
      "userId": userdata?.extension,
      "status": userdata?.status === 1 ?"unblock":"block",  
      "sip_id": formData.sip_login_id
    }
    new eventService().saveBlockUnblock(data)
      .then((res: any) => {
        console.log(res, 'error');
    
       
      }).catch((error: any) => {
        console.log(error, 'error');

      });
  }
  catch (error: any) { console.log("error", error); }
};